import React from 'react'
import { Grid } from '@material-ui/core'

import DailyMonitoringResumeTemplate from '../../templates/DailyMonitoringResumeTemplate'
// import DailyMonitoringTemplate from '../../templates/DailyMonitoringTemplate'
import DateInfo from '../../containers/dailyMonitoring/details/resume/DateInfo'
import MainSummary from '../../containers/dailyMonitoring/details/resume/MainSummary'
import DailyTotals from '../../containers/dailyMonitoring/details/resume/DailyTotals/Index'

// CANCELLED
import CancelledSummary from '../../containers/dailyMonitoring/details/resume/cancelled/CancelledSummary'
import DailyTotalsCancelled from '../../containers/dailyMonitoring/details/resume/cancelled/DailyTotals/Index'

const DailyMonitoringDetails = (): JSX.Element => {
  return (
    <DailyMonitoringResumeTemplate>
      <Grid item xs={12}>
        <DateInfo />
      </Grid>
      <Grid item style={{ display: 'flex', flexDirection: 'row' }} xs={12}>
        <Grid item xs={7}>
          <MainSummary />
        </Grid>
        <Grid item xs={5} style={{ paddingLeft: 5 }}>
          <DailyTotals />
        </Grid>
      </Grid>
      <Grid item xs={12} style={{ display: 'flex', flexDirection: 'row' }}>
        <Grid item xs={7}>
          <CancelledSummary />
        </Grid>
        <Grid item xs={5} style={{ paddingLeft: 5 }}>
          <DailyTotalsCancelled />
        </Grid>
      </Grid>
    </DailyMonitoringResumeTemplate>
  )
}

export default DailyMonitoringDetails
